import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import Input from 'modules/core/components/Inputs/Text'
import i18n from 'modules/core/lib/i18n'
import validateNumberInput from 'modules/core/lib/validateNumberInput'

export interface ToleranceSettingsProps {
  label: string
  minutesFormField: Field
  mandatory: boolean
}

const MinutesInput = ({ label, minutesFormField, mandatory }: ToleranceSettingsProps) => {
  return (
    <Box gap="s8" width="full">
      <Text.Normal color="grey1000" size="200">
        {label}
      </Text.Normal>
      <Box gap="s8" flexDirection="row" alignItems="center" width="full">
        <Box width="s64" flexNoShrink>
          <Input
            field={minutesFormField}
            placeholder="--"
            min={0}
            mandatory={mandatory}
            validation={() => validateNumberInput(minutesFormField.value, true)}
          />
        </Box>
        <Box
          background="grey200"
          width="full"
          padding="s8"
          borderRadius={{
            all: 'abs008',
          }}
          border={{
            all: {
              width: 's2',
              style: 'solid',
              color: 'grey400',
            },
          }}
        >
          <Text.Normal color="grey600">
            {i18n.t('time_tracking.settings.tolerance_settings.scheduled_shifts.minutes')}
          </Text.Normal>
        </Box>
      </Box>
    </Box>
  )
}

export default observer(MinutesInput)
